export const ASYNC_TASK_KEY = 'task_id'

export const ASYNC_TASK_EXPORT_INTERVAL = 30000

export const ASYNC_TASK_SUCCESS_STATUS = 'success'

export const ASYNC_TASK_FAILED_STATUS = 'failed'
